import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Autocomplete,
  TextField,
  Chip,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { BASE_URL } from "../../../config/apiConfig";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { getHeaders } from "../../../utils/apiUtils";
import { attributeScreenConfig } from "../../../config/attributeTypes";

function AttributeGroupDropdown({
  attributeType,
  attributeGroup,
  setAttributeGroup,
  sx,
  label,
  error = false,
  helperText = "",
}) {
  const ChipLabelWithIcons = ({ name, isRequired, isCarryForward }) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {isRequired && (
        <CheckCircleOutlineIcon
          sx={{ color: palette.primary[700], fontSize: "20px" }}
        />
      )}
      {isCarryForward && (
        <KeyboardDoubleArrowLeftIcon
          sx={{ color: palette.primary[700], fontSize: "20px" }}
        />
      )}
      <Typography variant="body2" component="span">
        {name}
      </Typography>
    </Box>
  );

  const { palette } = useTheme();
  const [attributeGroups, setAttributeGroups] = useState([]);

  useEffect(() => {
    const fetchAttributeGroups = async () => {
      let headers = await getHeaders();
      axios
        .get(
          `${BASE_URL}tools/admin/attribute-groups/${attributeType}?extended=true`,
          headers
        )
        .then((res) => {
          setAttributeGroups(res.data.data);
        })
        .catch((err) => {
          alert(
            `Failed to fetch ${attributeScreenConfig[attributeType]?.name} groups`
          );
        });
    };

    if (attributeType) {
      fetchAttributeGroups();
    }
  }, [attributeType]);

  const handleAddAttributeGroup = (_, newValue) => {
    setAttributeGroup(attributeType, newValue);
  };

  return (
    <Box
      sx={{
        borderRadius: 1,
        overflow: "auto",
        ...sx,
      }}
    >
      <Typography variant="h5">
        {label ? label : `${attributeScreenConfig[attributeType]?.name} Group`}
      </Typography>
      <Autocomplete
        disablePortal
        sx={{
          mt: 1,
        }}
        value={attributeGroup}
        options={attributeGroups}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.group_name || ""}
        onChange={handleAddAttributeGroup}
        renderInput={(params) => (
          <TextField
            {...params}
            label={`Select ${attributeScreenConfig[attributeType]?.name} group`}
            error={error}
            helperText={helperText}
          />
        )}
      />
      <Box sx={{ display: "flex", flexWrap: "wrap", mt: 1 }}>
        {attributeGroup?.attributes?.map((attribute) => (
          <Chip
            key={attribute.id}
            label={
              <ChipLabelWithIcons
                name={
                  attribute.name ? attribute.name : attribute.attribute_name
                }
                isRequired={attribute.required}
                isCarryForward={attribute.carry_forward}
              />
            }
            sx={{
              mr: 1,
              mb: 1,
              backgroundColor: palette.primary[20],
            }}
          />
        ))}
      </Box>
    </Box>
  );
}

export default AttributeGroupDropdown;
